<template>
    <div>

        <div class="col-xs-12" :style="{'background-size': '100% auto'}" style="margin:4px;padding:4px;background:#ddd8d8;border-radius:4px;padding-bottom:10px;">
            <div style="padding:2px;font-weight:bold;">

                <div v-if="item.category!==null">
                    <div class="label label-primary" style="z-index:999;display:inline-block;">{{item.parentCategory.name}} </div> /
                    <div class="label label-info" style="z-index:999;display:inline-block;"> {{item.category.name}} </div>

                </div>
                <div v-if="!showThumbnail">{{item.title}}</div>
            </div>

            <div style="display: flex; flex-wrap: wrap;">
                <div v-if="showThumbnail" class="col-xs-12" :class="{'col-md-6':isSideBySide}" style="position:relative;" :style="{'background':'url('+item.thumbPath+')','background-size': '100% auto'}">
                    <div class="agx-trans-layer"></div>
                    <div class="col-xs-12">
                        <div style="display: inline-block; width: 100%;text-align:center;">
                            <img style="display:inline-block;border-radius:12px;"
                                 class="agx-post-thumb img-responsive" :src="item.thumbPath" :title="item.title">
                        </div>
                        <div style="text-align:center;">
                            <template v-if="item.images.length>1">
                                <img class="img-responsive" v-for="(img,index) in item.images" v-if="index!==0" :src="img.thumbPath" style="display:inline-block;width:100px;border-radius:12px;margin:4px;" />
                            </template>
                        </div>
                    </div>
                    <div style="position:absolute;width: 100%;left:0px; bottom: 0px; text-align: center;line-height:30px;font-size:1.4em;font-weight: bold; background: rgba(251, 249, 249, 0.7); border-radius: 10px;">
                        <div style="display: flex; justify-content: center; align-items: center;min-height:60px;width: 100%; ">
                            <span>{{item.title}}</span>
                        </div>
                    </div>
                </div>

                <div class="col-xs-12" :class="{'col-md-6':isSideBySide && item.thumbPath!==null}" v-if="videos.length>0"  style="background: #f5f5f5;border-radius: 10px; ">
                    <div class="col-xs-12" :class="{'col-md-6':videos.length>1}" v-for="link in videos" style="padding-left: 0px; padding-right: 0px; background: #f5f5f5;border-radius: 10px; ">
                        <div style="display: inline-block;width:100%; ">
                            <media-link :item="link"></media-link>
                        </div>
                    </div>
                </div>
            </div>         


            <div class="col-xs-12" v-if="item.textMsg!==null && item.textMsg!==''" style=" margin-bottom: 4px;padding-left: 0px; padding-right: 0px;">
                <div class="col-xs-12" style="white-space: pre-line; text-align: center; background: #f5f5f5;" v-if="item.textMsg!==''">
                    {{item.textMsg}}
                </div>
            </div>

            <div class="col-xs-12" style="display: flex; flex-wrap: wrap; padding-left: 0px; padding-right: 0px;margin-top:1px;">
                <div class="col-xs-12 col-sm-12" :class="{'col-md-6':links.length>1}" v-for="link in links" style="background: #f5f5f5; border-radius: 10px; ">
                    <div style="display: inline-block; width: 100%; ">
                        <dual-link :item="link"></dual-link>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>
<script>
    import mediaLink from '../links/mediaLink.vue';
    import dualLink from '../links/dualLink.vue';
    export default {
        components: {
            mediaLink: mediaLink,
            dualLink: dualLink
        },
        filters: {

        },
        props: ["item", "itemType"],
        computed: {
            showThumbnail: function () {
                return this.item.thumbPath !== null;
            },
            isSideBySide: function () {
                return this.videos.length === 1;
            },
            links: function () {
                if (this.item.links !== null) {
                    return this.item.links.filter((it) => { return it.linkType === 0 });
                }
                return [];
            },
            videos: function () {
                if (this.item.links !== null) {
                    return this.item.links.filter((it) => { return it.linkType === 1 });
                }
                return [];
            }
        },
        data: function () {
            return {

            }
        },
        mounted: function () {

        }
    }
</script>